document.addEventListener('alpine:init', () => {
  Alpine.data('CartFooter', () => {
    return {
      footerRoot: null,
      _morphFooter(e) {
        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          e.detail.response.sections['cart-footer']
        );

        Alpine.morph(
          this.footerRoot,
          newFooterSection ? newFooterSection.outerHTML : '',
          {
            updating(el, toEl, childrenOnly, skip) {
              if (
                el.classList &&
                el.classList.contains('additional-checkout-buttons')
              ) {
                skip();
              }
            },
          }
        );
      },
      init() {
        this.footerRoot = this.$root;

        window.addEventListener('baseline:cart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('baseline:cart:cartqtychange', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('baseline:cart:update', (e) => {
          this._morphFooter(e);
        });
      },
    };
  });
});

// aino.ar integration
// debug version
const ainoIntegrationTestMode = false;

// Function to add multiple products to the cart using the Shopify AJAX API
function addToCart(items) {
  const cartData = {
    items: items  // Array of items to add to the cart
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartData)
  })
  .then(response => response.json())
  .then(data => {
    if (!data.errors && data.status != 'bad_request') {
      if (ainoIntegrationTestMode) {
        console.log('Products added successfully:', data);
      }
      // Optionally, redirect or update the cart UI
      if (!ainoIntegrationTestMode) {
        window.location.href = '/cart'; // Redirect to cart
      }
    } else {
      console.error('Error adding to cart:', data.errors);
      if (ainoIntegrationTestMode) {
        alert('Failed to add products to cart');
      }
    }
  })
  .catch(error => {
    console.error('Error:', error);
    if (ainoIntegrationTestMode) {
      alert('Failed to add products to cart');
    }
  });
}

// Check if new cart data is sent via URL parameters
function getCartDataFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const cartData = params.get('cartData');
  return cartData ? JSON.parse(decodeURIComponent(cartData)) : null;
}

// If new cart data is detected, trigger addToCart for all items at once
const newAinoCartData = getCartDataFromUrl();
if (newAinoCartData) {
  if (ainoIntegrationTestMode) {
    console.log('Detected new cart data:', newAinoCartData);
  }
  addToCart(newAinoCartData); // Add all items in one request
}

// Optionally, clear URL parameters after processing
if (newAinoCartData) {
  const cleanUrl = window.location.pathname;
  window.history.replaceState({}, document.title, cleanUrl);
}

